import { safeParse, string, uuid } from "valibot";

import { debugLogSettings } from "shared/functions";
import { AppConfiguration } from "shared/types";
const getDefaultOrigin = () => {
  if (window.location.hostname === "localhost") {
    return window.location.origin;
  }
  return "error";
};

const backwardsHttpIpRegex =
  /^(http|https):\/\/((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)-?\b){4}/;
const decodeUrlFromSearch = (encodedOrigin: string | null) => {
  if (!encodedOrigin) {
    return "";
  } else if (backwardsHttpIpRegex.test(encodedOrigin)) {
    // Safari doesn't support lookbehind
    // return encodedOrigin.replaceAll(/(?<=\d)-+(?=\d)/g, ".");
    return encodedOrigin.replaceAll("-", ".");
  }
  return encodedOrigin.replace("local-host", "localhost");
};

const UUIDSchema = string([uuid()]);

export const getAppSettings = (): AppConfiguration => {
  const searchParams = new URLSearchParams(window.location.search);

  const serviceBaseUrl =
    decodeUrlFromSearch(searchParams.get("service-base-url")) ||
    process.env.REACT_APP_SERVICE_BASE_URL ||
    "error";

  const token =
    searchParams.get("token") || process.env.REACT_APP_TOKEN || "error";

  const baseOriginParam = decodeUrlFromSearch(searchParams.get("base-origin"));
  const isIframe = !!decodeUrlFromSearch(searchParams.get("standalone"));
  const isPreviewIframeFromDashboard = !!decodeUrlFromSearch(
    searchParams.get("is-preview-iframe-from-dashboard"),
  );
  const isWidgetPreview = !!decodeUrlFromSearch(
    searchParams.get("isWidgetPreview"),
  );
  const pageUrl = decodeUrlFromSearch(searchParams.get("page-url"));
  const autofocusOff = !!decodeUrlFromSearch(searchParams.get("autofocus-off"));

  const baseOrigin = baseOriginParam || getDefaultOrigin();

  const instanceName =
    decodeUrlFromSearch(searchParams.get("instance-name")) || "error";

  const chatIdParam = searchParams.get("chat-id");
  const result = safeParse(UUIDSchema, chatIdParam);
  const chatId = result.success ? result.output : undefined;

  debugLogSettings.useConsole = [
    "localhost",
    "staging.writesonic.com",
  ].includes(new URL(baseOrigin).hostname);

  return {
    isIframe,
    isPreviewIframeFromDashboard,
    isWidgetPreview,
    pageUrl,
    serviceBaseUrl,
    token,
    baseOrigin,
    instanceName,
    chatId,
    autofocusOff,
  };
};
